<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Registrar salida
            <router-link
              :to="{ name: 'Salida'
             , params: { config: config }
             }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value.sync="$v.date.$model"
                  :isValid="checkIfValid('date')"
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Almacén:</label>
                <v-select
                  v-model="almacen"
                  :options="almacenes"
                  :loading="isLoadingPage"
                  @input="onChangeAlmacen"
                  class="margin-multi"
                  placeholder="Selecciona un almacén"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    :multiple="true"
                    :loading="isLoadingPage"
                    label="label"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                    :close-on-select="false"
                    :clear-on-select="false"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multi && multi.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CTextarea
                  :value.sync="comentarios"
                  :label="`Comentarios: `"
                  placeholder="Comentarios..."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <hr class="my-4 line" />
            <CRow class="mb-3">
              <CCol md="4" lg="4" xl="4">
                <v-select
                  v-model="producto"
                  :options="productos"
                  :selectable="isProductoSelectable"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  @input="getUnidad()"
                  placeholder="Producto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
              <CCol md="4" lg="4" xl="3">
                <CInput v-model="unidad" readonly placeholder="Unidad..." type="text" />
              </CCol>
              <CCol md="4" lg="4">
                <CInput
                  :value.sync="$v.cantidad.$model"
                  :isValid="checkIfValid('cantidad')"
                  placeholder="Cantidad"
                  type="number"
                  :max="getExistencia(producto ? producto.value : null)"
                  min="1"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
              <CCol xl="1">
                <CButton @click="addProducto()" class="float-right" color="success">Agregar</CButton>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="detalles"
                  :fields="fieldsSecondModal"
                >
                  <template #producto_id="{item}">
                    <td class="py-2">{{ getProducto(item.producto_id) }}</td>
                  </template>
                  <template #unidad="{item}">
                    <td class="py-2">{{ getProdUnidad(item.producto_id) }}</td>
                  </template>
                  <template #cancel="{ index}">
                    <td class="py-2">
                      <CButton color="danger" square size="sm" @click="deleteDetalle(index)">Borrar</CButton>
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Salida', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addSalida()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Salida"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
        size="sm"
        title="Salida"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="successModal = false"  color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

const fieldsSecondModal = [
  { key: "producto_id", _style: "width:30%" },
  { key: "unidad", label: "Unidad", _style: "width:30%" },
  { key: "cantidad", _style: "width:30%" },
  {
    key: "cancel",
    label: "",

    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "NuevoSalida",

  components: {
    Multiselect,
    vSelect
  },

  data() {
    return {
      multi: null,
      config: this.$route.params.config,
      ubicaciones: [],
      ubicacionesAll: [],
      detalles: [],
      date: null,
      almacen: "",
      serie: "",
      almacenes: [],
      unidad: "Unidad",
      fieldsSecondModal,
      productos: [],
      producto: null,
      productosAll: [],
      productosExistencias: [],
      warningModal: false,
      successModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      cantidad: null,
      comentarios: '',
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    cantidad: {
      required,
      notNegative: (value) => value >= 0
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    isValidCantidad() {
      return !this.$v.cantidad.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->raiz_id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "almacenes",
        filter: {
          wherein: [
            {
              field: "payload->ubicacion_id",
              value: [this.ubicacionRaizValue]
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "productos",
        filter: {
          where: [
            {
              field: "payload->unidad",
              value: "",
              operator: "!="
            }
          ]
        }
      })
    ];

    if (this.ubicacionRaizValue) {
      ubi.push(ubicacionTemplateRaiz);
    } else {
      ubi.push(ubicacionTemplateNoRaiz);
    }

    Promise.all(ubi)
      .then(([almacenes, productos, ubicaciones]) => {
        this.almacenes = almacenes.data.map(almacen => {
          return { value: almacen.id, label: almacen.payload.nombre };
        });
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.productosAll = productos.data;
        this.ubicacionesAll = ubicaciones.data;
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    getProducto(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.nombre;
    },
    getProdUnidad(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.unidad;
    },
    toggleLote(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    addProducto() {
      this.validateProducto();

      if (this.producto && this.isValidCantidad) {
        // this.detalles.push(this.nombreEtapa);
        this.detalles.push({
          producto_id: this.producto.value,
          cantidad: Number(this.cantidad)
        });

        // recalculamos la existencia
        this.productos = this.productos.map(producto => {
          if (producto.value === this.producto.value) {
            const cantidadExistente = this.detalles.reduce((acc, detalle) => {
              if (detalle.producto_id === producto.value) {
                return acc + detalle.cantidad;
              }
              return acc;
            }, 0);

            const productoActual = this.productosExistencias.find(
              p => p.id === this.producto.value
            );

            const existenciaActual = Math.max(0, productoActual.existencia_actual - cantidadExistente);

            if (existenciaActual) {
              producto.label = `${productoActual.producto} (${existenciaActual} ${productoActual.unidad})`;
              producto.disabled = false;
            } else {
              producto.label = `${productoActual.producto} (Sin existencia)`;
              producto.disabled = true;
            }
          }
          return producto;
        }).sort((a, b) => {
          if (a.disabled && !b.disabled) return 1;
          if (!a.disabled && b.disabled) return -1;
          return 0;
        });

        this.resetProducto();
      }
    },
    getUnidad() {
      if (this.producto) {
        const productoActual = this.productosAll.filter(
          producto => producto.id == this.producto.value
        );

        this.unidad = productoActual[0].payload.unidad;
      } else {
        this.unidad = "Unidad";
      }
    },
    getExistencia() {
      if (this.producto) {

        // menos cantidad de la lista de detalles
        const cantidadExistente = this.detalles.reduce((acc, detalle) => {
          if (detalle.producto_id === this.producto.value) {
            return acc + detalle.cantidad;
          }
          return acc;
        }, 0);

        const productoActual = this.productosExistencias.find(
          p => p.id === this.producto.value
        );

        return Math.max(0, productoActual.existencia_actual - cantidadExistente);
      } else {
        return 0;
      }
    },
    deleteDetalle(index) {
      if (index !== -1) {

        const productoId = this.detalles[index].producto_id;
        this.detalles.splice(index, 1);

        // Recalculamos la existencia del producto eliminado
        this.productos = this.productos.map(producto => {
          if (producto.value === productoId) {
            const cantidadExistente = this.detalles.reduce((acc, detalle) => {
              if (detalle.producto_id === producto.value) {
                return acc + detalle.cantidad;
              }
              return acc;
            }, 0);

            const productoActual = this.productosExistencias.find(
              p => p.id === producto.value
            );

            const existenciaActual = Math.max(0, productoActual.existencia_actual - cantidadExistente);

            if (existenciaActual) {
              producto.label = `${productoActual.producto} (${existenciaActual} ${productoActual.unidad})`;
              producto.disabled = false;
            } else {
              producto.label = `${productoActual.producto} (Sin existencia)`;
              producto.disabled = true;
            }
          }
          return producto;
        }).sort((a, b) => {
          if (a.disabled && !b.disabled) return 1;
          if (!a.disabled && b.disabled) return -1;
          return 0;
        });
      }
    },
    async addSalida() {
      this.validateSalida();
      this.fetching = true
      this.isLoading = true;
      await (new Promise((res,)=>{
        const iter = setInterval(()=>{
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
          debugger
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }

      if (this.isValidDate) {
        if (!this.almacen) {
          this.error = "El campo almacén es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        let newDate = moment(this.date, "YYYY-MM-DD HH:mm:ss");
        this.multi ? "" : (this.multi = []);
        let valueUbicaciones = this.multi.map(item => item.value);

        this.$store
          .dispatch("customDocumentoAddHTTP", {
            schema: "salidas",
            payload: {
              encabezado: {
                fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                almacen_id: this.almacen ? this.almacen.value : "",
                // serie: this.serie,
                ubicaciones: valueUbicaciones,
                ubicacion_raiz_id: this.ubicacionRaiz
                  ? this.ubicacionRaiz.value
                  : null,
                comentarios: this.comentarios || '',
              },
              anexos: this.medias,
              detalles: this.detalles,
            }
          })
          .then(() => {
            // this.$router.push({ name: "Salida" });
            this.currentAlertCounter = 6;
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.isLoading = false;
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateSalida() {
      this.$v.date.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    validateProducto() {
      this.$v.cantidad.$touch();
    },
    resetProducto() {
      this.cantidad = null;
      this.unidad = "Unidad";
      this.producto = null;
      this.$v.cantidad.$reset();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingPage = true;
      this.$store;

      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaizValue]
              }
            ]
          }
        })
      ];

      if (this.ubicacionRaizValue) {
        ubi.push(ubicacionTemplateRaiz);
      } else {
        ubi.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(ubi)
        .then(([almacenes, ubicaciones]) => {
          this.almacenes = almacenes.data.map(almacen => {
            return { value: almacen.id, label: almacen.payload.nombre };
          });

          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    cleanMulti() {
      this.multi = [];
    },
    onChangeAlmacen() {

      this.isLoadingPage = true;

      let template = {
        body: {
          reporte: "saldos_concentrado",
          params: {
            ubicaciones: [this.ubicacionRaizValue],
            almacen_id: this.almacen.value
          }
        }
      };

      this.$store.dispatch("customIndicadoresHTTP", template).then(res => {

        this.productosExistencias = res.data;

        this.productos = this.productosAll.map(producto => {
          const productoExistencia = this.productosExistencias.find(item => item.producto === producto.payload.nombre);
          if (productoExistencia) {
            productoExistencia.id = producto.id;
          }
          return {
            value: producto.id,
            label: `${producto.payload.nombre} ${productoExistencia ? `(${productoExistencia.existencia_actual} ${producto.payload.unidad})` : '(Sin existencia)'}`,
            disabled: productoExistencia ? false : true
          };
        }).sort((a, b) => {
          if (a.disabled && !b.disabled) return 1;
          if (!a.disabled && b.disabled) return -1;
          return 0;
        });

        this.isLoadingPage = false;

      }).catch(err => {
        console.error("Error al obtener los productos:", err);
        this.isLoadingPage = false;
      });
    },
    isProductoSelectable(option) {
      return option.disabled !== true;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
